import Control from "../../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPRORestauration = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  return (
    <div>
      <Control
        label={inputsConfig.restaurationTypeRestauration.label}
        type="checkBtnList"
        name="restaurationTypeRestauration"
        value={company.RCPRO.restaurationTypeRestauration}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.restaurationTypeRestauration.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles</>}
      />
      <Control
        label={inputsConfig.restaurationRespectHACCP.label}
        type="btnList"
        name="restaurationRespectHACCP"
        value={company.RCPRO.restaurationRespectHACCP}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.restaurationRespectHACCP.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPRORestauration;
